export default __webpack_public_path__ + "static/media/price-bg-balls.083e4044.png";